import { IDBPDatabase } from "idb/build/esm/entry";
import VmsDbSchema from "@/models/VmsDbSchema";
import DataService from "@/services/data-service/data-service";
import PortsService from "@/services/portsService";
import IPort from "@/models/port";
import IResponse from "@/models/response";

export default class DataPortService {
  private portService = new PortsService();
  private ports: IPort[] | null = null;

  constructor(private $db: Promise<IDBPDatabase<VmsDbSchema>>, private $dataService: DataService) {}

  public actions = {
    GetByManyId: this.getByManyId.bind(this),
    GetById: this.getById.bind(this),
    SearchByName: this.searchByName.bind(this)
  };

  public async initialize() {
    const ports = await this.portService.get();
    for (const port of ports)
      await (
        await this.$db
      ).put("Ports", {
        id: port.id ?? 0,
        name: port.name ?? "not defined",
        value: JSON.stringify(port)
      });
  }

  private getById(id: number) {
    return this.getByManyId([id]);
  }

  private async getByManyId(ids: number[]) {
    if (!this.$dataService.getters.isOfflineSupport()) return this.portService.getByManyId(ids);
    if (this.ports == null) this.ports = await this.getAllPorts();

    const idsNetwork = [];
    let results: IPort[] = [];
    for (const id of ids) {
      const r = this.ports.find(x => x?.id === id);
      if (r) {
        results.push(r);
        continue;
      }
      idsNetwork.push(id);
    }
    if (idsNetwork.length > 0 && this.$dataService.getters.isOnline())
      results = [...results, ...(await this.portService.getByManyId(idsNetwork))];
    return results;
  }

  private async searchByName(portName: string) {
    if (!this.$dataService.getters.isOfflineSupport() || this.$dataService.getters.isOnline())
      return this.portService.searchByName(portName);
    if (this.ports == null) this.ports = await this.getAllPorts();
    const result = this.ports.filter(x => x.name?.includes(portName));
    return {
      data: result,
      totalItems: result.length
    } as IResponse<IPort>;
  }

  private async getAllPorts() {
    const ports: IPort[] = [];
    const portsDb = await (await this.$db).getAll("Ports");
    for (const p of portsDb) ports.push(JSON.parse(p.value));
    return ports;
  }
}
